module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/208-palestine-5e51e03ef2ec03a24b5f3719c3c56422.svg";